import qs from "qs";
import { useLanguageStore } from "~/store/languageStore";
import { useProductFilterStore } from "~/store/productFilter.store.js";
import { productFilterConfig } from "~/config/productFilter.config.js";

export const getPagesQuery = (path) => {
  return qs.stringify({
    locale: useLanguageStore().language?.name,
    path,
    fields: ["metaTitle", "metaDescription"],
  });
};

export const getSelectionsQuery = (categoryCode) => {
  return qs.stringify({
    locale: useLanguageStore().language?.name,
    fields: ["title", "description", "metaTitle", "metaDescription"],
    specifications: productFilterConfig["specifications"].state.encode(
      useProductFilterStore().params.specifications,
    ),
    categoryCode,
  });
};

export const getHomeSliderQuery = () => {
  return qs.stringify({
    locale: useLanguageStore().language.name,
    populate: ["backgroundImage", "overlayImage"],
    fields: [
      "title",
      "titleColor",
      "url",
      "description",
      "descriptionColor",
      "buttonLabel",
      "buttonLabelColor",
      "buttonBackgroundColor",
    ],
    sort: "position:asc",
  });
};

export const getCategorySliderQuery = () => {
  return qs.stringify({
    locale: useLanguageStore().language.name,
    populate: ["image"],
    fields: ["title", "url", "description"],
    sort: "position:asc",
  });
};

export const getPopupSliderQuery = () => {
  return qs.stringify({
    locale: useLanguageStore().language.name,
    populate: ["backgroundImage", "overlayImage"],
    fields: [
      "title",
      "titleColor",
      "url",
      "description",
      "descriptionColor",
      "buttonLabel",
      "buttonLabelColor",
      "buttonBackgroundColor",
      "buttonBorderColor",
    ],
    sort: "position:asc",
  });
};

export const getHeaderBannerQuery = () => {
  return qs.stringify({
    populate: ["image", "adaptiveImage"],
    fields: ["title", "url"],
  });
};
